export enum ApprovedBetSlipStatus {
	WAITING_FOR_RESPONSE = 0,
	SLIP_ACCEPTED = 1,
	STAKE_CHANGED = 2,
	ODDS_CHANGED = 3,
	STAKE_AND_ODDS_CHANGED = 4,
	SLIP_CANCELLED = 10,
}

export interface ApprovedBetSlipData {
	customerId: number;
	slipId: number;
	status: ApprovedBetSlipStatus;
	traderAcceptationTime: number | null;
	stake: number;
	newStake: number | null;
	oddsChanges: number | null;
	possibleWin: number;
	newPossibleWin: number | null;
	slipType: number;
	regMethod: number;
	customSlipId?: string;
	slipJSON: any;
	newTotalOdds: number | null;
}
